import React from "react";
import shape2 from "../assets/images/shape/circle-shape2.png";
import client1 from "../assets/images/testimonials/client1.jpg";
import client2 from "../assets/images/testimonials/client2.jpg";
import client3 from "../assets/images/testimonials/client3.jpg";
import Loadable from "@loadable/component";
import { fontsName } from "../assets/fonts/fontsName";
import { request, gql } from "graphql-request";
import { REQUEST_URL } from "./RequestUrl";
const OwlCarousel = Loadable(() => import("react-owl-carousel3"));

const options = {
  loop: true,
  nav: true,
  dots: false,
  autoplayHoverPause: true,
  autoplay: true,
  margin: 30,
  navText: [
    "<i class='flaticon-left-1'></i>",
    "<i class='flaticon-right-1'></i>",
  ],
  responsive: {
    0: {
      items: 1,
    },
    768: {
      items: 2,
    },
    992: {
      items: 2,
    },
  },
};

const query = gql`
  {
    getAllWebsiteFamousSpeeches {
      _id
      personName
      speech
    }
  }
`;

const WordsEdlers = () => {
  const [display, setDisplay] = React.useState(false);
  const [famousEpeechesList, setFamousEpeechesList] = React.useState([]);

  React.useEffect(() => {
    setDisplay(true);
  }, []);
  React.useEffect(() => {
    request(REQUEST_URL, query).then((data) => {
      setFamousEpeechesList(data.getAllWebsiteFamousSpeeches);
    });
  }, []);
  return (
    <section className="services-area ptb-100 bg-f1f8fb">
      <div className="container">
        <div className="section-title">
          <h2 style={{ fontFamily: fontsName.Vazir, color: "#6200EA" }}>
            کلام بزرگان
          </h2>
          <p
            style={{
              width: "25%",
              height: "4px",
              backgroundColor: "#FFFF00",
              marginTop: "20px",
            }}
          ></p>
        </div>

        {display ? (
          <OwlCarousel
            className="testimonials-slides owl-carousel owl-theme"
            {...options}
          >
            {famousEpeechesList && famousEpeechesList.length > 0
              ? famousEpeechesList.map((speech, index) => (
                  <div key={index} className="single-testimonials-item">
                    <p
                      style={{
                        direction: "rtl",
                        fontFamily: fontsName.VazirBold,
                        fontSize: "16px",
                      }}
                    >
                      {speech.speech}
                    </p>

                    <div className="client-info">
                      <div className="d-flex justify-content-center align-items-center">
                        {/* <img src={client1} alt="testimonial" /> */}
                        <div className="title">
                          <h3
                            style={{
                              direction: "rtl",
                              fontFamily: fontsName.Vazir,
                              fontSize: "17px",
                            }}
                          >
                            {speech.personName}
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              : ""}

            {/* <div
              className="single-testimonials-item"
            >
              <p style={{ direction: "rtl", fontFamily: fontsName.VazirBold }}>
                لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با
                استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله
                در ستون و سطرآنچنان که لازم است.
              </p>

              <div className="client-info">
                <div className="d-flex justify-content-center align-items-center">
                  <img src={client1} alt="testimonial" />
                  <div className="title">
                    <h3
                      style={{ direction: "rtl", fontFamily: fontsName.Vazir }}
                    >
                      لورم فارسی
                    </h3>
                    
                  </div>
                </div>
              </div>
            </div>

            <div className="single-testimonials-item">
              <p style={{ direction: "rtl", fontFamily: fontsName.VazirBold }}>
                لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با
                استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله
                در ستون و سطرآنچنان که لازم است.
              </p>

              <div className="client-info">
                <div className="d-flex justify-content-center align-items-center">
                  <img src={client2} alt="testimonial" />
                  <div className="title">
                    <h3
                      style={{ direction: "rtl", fontFamily: fontsName.Vazir }}
                    >
                      لورم فارسی
                    </h3>
                    
                  </div>
                </div>
              </div>
            </div>

            <div className="single-testimonials-item">
              <p style={{ direction: "rtl", fontFamily: fontsName.VazirBold }}>
                لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با
                استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله
                در ستون و سطرآنچنان که لازم است.
              </p>
              <div className="client-info">
                <div className="d-flex justify-content-center align-items-center">
                  <img src={client3} alt="testimonial" />
                  <div className="title">
                    <h3
                      style={{ direction: "rtl", fontFamily: fontsName.Vazir }}
                    >
                      لورم فارسی
                    </h3>
                  </div>
                </div>
              </div>
            </div> */}
          </OwlCarousel>
        ) : (
          ""
        )}
      </div>

      <div className="circle-shape2">
        <img src={shape2} alt="banner" />
      </div>
      <div className="lines">
        <div className="line"></div>
        <div className="line"></div>
        <div className="line"></div>
        <div className="line"></div>
        <div className="line"></div>
      </div>
    </section>
  );
};

export default WordsEdlers;
